import { useQuery } from 'convex/react'
import { api } from '@backend/_generated/api'
import type { OrganizationWithRoles } from '../types'

/**
 * Returns all organizations the logged-in user belongs to, with their role.
 * Data comes from Convex (replaces the old Hono API call).
 */
export const useOrganizationData = (): Array<OrganizationWithRoles> => {
  const data = useQuery(api.profile.getMyOrganizations)

  if (!data) return []

  return data.map((org) => ({
    id: org.membershipId,
    externalId: org.organizationId,
    name: org.name,
    description: org.description ?? undefined,
    logo: org.logo ?? undefined,
    linkColor: org.linkColor ?? undefined,
    backgroundColor: org.backgroundColor ?? undefined,
    isAdmin: org.isAdmin,
    roles: org.roles,
  }))
}
